<template>
              <div class="element-box">
<form v-if="!exibeMsgSucesso" autocomplete="off" @submit.prevent="salvar()">
            <div class="form-row">
              <div class="col">
                <fieldset class="form-group">
                  <legend class="w-auto">
                    <span>A unidade a ser cadastrada é?</span>
                  </legend>
                  <div class="row">
                      <div class="col">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input required v-model="unidadeMatrizFilial" value="MATRIZ" type="radio" class="custom-control-input" id="unidadeMatriz" name="unidadeMatrizFilial">
                            <label class="custom-control-label" for="unidadeMatriz">Matriz</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input required v-model="unidadeMatrizFilial" value="FILIAL" type="radio" class="custom-control-input" id="unidadaFilial" name="unidadeMatrizFilial">
                            <label class="custom-control-label" for="unidadaFilial">Filial</label>
                        </div>
                      </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <fieldset class="form-group">
                  <legend class="w-auto">
                    <span>Dados Básicos</span>
                  </legend>
                  <div class="row">
                    <div class="col">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input v-model="tipoPessoa" value="PF" type="radio" class="custom-control-input" id="tipoPessoaPF" name="tipoPessoa">
                            <label class="custom-control-label" for="tipoPessoaPF">Pessoa Física</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input v-model="tipoPessoa" value="PJ" type="radio" class="custom-control-input" id="tipoPessoaPJ" name="tipoPessoa">
                            <label class="custom-control-label" for="tipoPessoaPJ">Pessoa Jurídica</label>
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col col-md-6" v-if="isPJ">
                      <div class="form-group">
                        <label for="cnpj">CNPJ</label>
                        <input required type="text" name="cnpj" v-model="precadastro.cnpj" v-mask="'##.###.###/####-##'" id="cnpj" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      </div>
                    </div>
                    <div v-else-if="isPF" class="col col-md-6">
                      <div class="form-group">
                        <label for="cpf">CPF</label>
                        <input required type="text" name="cpf" v-model="precadastro.cpf" v-mask="'###.###.###-##'" id="cpf" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      </div>
                    </div>
                  </div>
                  <div class="form-row" v-if="isPJ">
                      <div class="col-sm-12 col-md-6 form-group">
                          <label for="nome">Nome/Razão Social</label>
                          <input type="text" v-model="precadastro.razaoSocial" name="nome" id="nome" class="form-control">
                      </div>
                      <div class="col col-sm-12 col-md-6 form-group">
                          <label for="nomeFantasia">Nome Fantasia</label>
                          <input type="text" v-model="precadastro.nomeRede" name="nomeFantasia" id="nomeFantasia" class="form-control">
                      </div>
                  </div>
                  <div class="form-row" v-else-if="isPF">
                      <div class="col  col-md-6 form-group">
                          <label for="nmPrestador">Nome Prestador</label>
                          <input type="text" v-model="precadastro.nomeRede" name="nmPrestador" id="nmPrestador" class="form-control">
                      </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="form-row">
                <div class="col ">
                    <fieldset class="form-group">
                        <legend class="w-auto"><span>Tipo de Unidade</span></legend>
                        <div class="custom-control" :class="{'custom-checkbox': typeInputTipoUnidade === 'checkbox', 'custom-radio': typeInputTipoUnidade === 'radio'}"
                          v-for="(tipoPrestador, key) in tiposRede" :key="tipoPrestador._id">
                            <input v-model="precadastro.tipo" :type="typeInputTipoUnidade" class="custom-control-input" 
                              :id="`termoPrivacidade${key}`" name="termoPrivacidade"
                              :value="tipoPrestador">
                            <label class="custom-control-label" :for="`termoPrivacidade${key}`">{{ tipoPrestador.nome }}</label>
                        </div>
                    </fieldset>
                </div>
            </div>
            <div class="form-row" v-if="isTipoClinica">
              <div class="col">
                <fieldset class="form-group">
                  <legend>
                    <span>Especialidade</span>
                  </legend>

                    <form class="form-inline" autocomplete="off" @submit.prevent="addEspecialidade">
                      <label class="sr-only" for="especialidade">Especialidade</label>
                      <v-select v-model="especialidadeTemp.especialidade" label="nome" id="especialidade"
                      class="col-md-4 mb-2 mr-sm-2 mb-sm-0"
                        placeholder="Digite para Filtrar a Especialidade..."
                        :filterable="false" :options="especialidades" @search="onSearchEspecialidade">
                          <template slot="no-options">
                          Digite para Filtrar a Especialidade...
                          </template>
                          <template slot="option" slot-scope="option">
                          <div class="d-center">
                              {{ option.nome }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                              {{ option.nome }}
                          </div>
                          </template>
                      </v-select>
                      <label class="sr-only" for="qtdProfissionais">QTD.</label>
                      <input v-model="especialidadeTemp.qtdProfissionais" required type="text" id="qtdProfissionais" name="qtdProfissionais"
                        placeholder="QTD. Profissionais" 
                        class="form-control mb-2 mr-sm-2 mb-sm-0">

                      <label class="sr-only" for="valorParticular">Valor Consulta (Particular)</label>
                      <money v-model.lazy="especialidadeTemp.valorParticular"
                        required type="text" id="valorParticular" name="valorParticular"
                        placeholder="Valor Consulta (particular)" 
                        class="form-control mb-2 mr-sm-2 mb-sm-0"></money>

                      <button type="submit" class="btn btn-primary" title="Adicionar">
                        <i class="fa fa-plus"></i>
                      </button>
                    </form>
                    <hr />
                    <div class="row">
                      <div class="col">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th>Especialidade</th>
                                <th>Qtd Profissionais</th>
                                <th>Valor Particular</th>
                                <th>Ação</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-if="listEspecialidade.length > 0" v-for="especialidadeTmp in listEspecialidade" :key="especialidadeTmp.especialidade">
                                <td>
                                  <span class="smaller lighter">{{ especialidadeTmp.especialidade.nome }}</span>
                                </td>
                                <td>
                                  <span>{{ especialidadeTmp.qtdProfissionais }}</span>
                                </td>
                                <td>
                                  <span>{{ especialidadeTmp.valorParticular | money }}</span>
                                </td>
                                <td class="row-actions">
                                  <a @click="removeEspecialidade(especialidadeTmp)" title="Remover">
                                    <i class="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                              <tr v-else>
                                <td colspan="4">
                                  <span>Fovor informar as especialidades atendidas</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                      </div>
                    </div>

                </fieldset>
              </div>
            </div>
            <div class="form-row" v-else-if="isConsultorioOuMedico">
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="especialidade">Especialidade</label>
                  <v-select v-model="precadastro.especialidade" label="nome" id="especialidade"
                        placeholder="Digite para Filtrar a Especialidade..."
                        :filterable="false" :options="especialidades" @search="onSearchEspecialidade">
                          <template slot="no-options">
                          Digite para Filtrar a Especialidade...
                          </template>
                          <template slot="option" slot-scope="option">
                          <div class="d-center">
                              {{ option.nome }}
                              </div>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                              {{ option.nome }}
                          </div>
                          </template>
                      </v-select>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <label for="valorParticular">Valor Consulta (Particular)</label>
                  <money v-model="precadastro.valorParticular"
                    required type="text" id="valorParticular" name="valorParticular"
                    placeholder="Valor Consulta (particular)" 
                    class="form-control mb-2 mr-sm-2 mb-sm-0"></money>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col">
                <fieldset class="form-group">
                  <legend>
                    <span>Contato</span>
                  </legend>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="telefone">Telefone Fixo</label>
                        <input type="tel" v-model="precadastro.telefone" v-mask="['(##) ####-####', '(##) #####-####']" name="telefone" id="telefone" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="celular">Telefone celular</label>
                        <input type="tel" v-model="precadastro.celular" v-mask="['(##) ####-####', '(##) #####-####']" name="celular" id="celular" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="email">Email</label>
                        <input type="email" v-model="precadastro.email" name="email" id="email" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <fieldset class="form-group">
                  <legend>
                    <span>Dados de acesso</span>
                  </legend>
                  <div class="row">
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="username">Usuário</label>
                        <input required type="text" v-model="precadastro.username" name="username" id="username" class="form-control mb-4 mr-sm-2 mb-sm-0" >
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="password">Senha</label>
                        <input required type="password" v-model="precadastro.password" name="password" id="password" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div class="form-group">
                        <label for="testPassword">Repetir Senha</label>
                        <input required type="password" v-model="repeteSenha" name="testPassword" id="testPassword" class="form-control mb-4 mr-sm-2 mb-sm-0" >   
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="form-row">
                <div class="col form-group">
                    <div class="custom-control custom-checkbox">
                        <input v-model="termoPrivacidade" type="checkbox" class="custom-control-input" id="termoPrivacidade" name="termoPrivacidade">
                        <label class="custom-control-label" for="termoPrivacidade">Li e estou de acordo com os termos de uso e política de privacidade.</label>
                        <small class="text-muted">
                          <a target="_blank" href="/static/termos_de_contrato_adesao_DR_V2.pdf">Termos de uso</a>
                        </small>
                    </div>
                </div>
            </div>
            <hr />
            <button :disabled="!termoPrivacidade" type="submit" class="btn btn-primary">Fazer Cadastro</button>

</form>
            </div>
</template>
<script>
import http from 'axios'
import _ from 'lodash'
export default {
  async created () {
    this.ufs = await this.$store.dispatch('getUfs')
    this.tiposRedeCache = await this.$store.dispatch('getTiposRede', '')
  },
  computed: {
    isPF () {
      return this.tipoPessoa === 'PF'
    },
    isPJ () {
      return this.tipoPessoa === 'PJ'
    },
    isConsultorioOuMedico () {
      return this.precadastro.tipo && (this.precadastro.tipo.nome === 'CONSULTORIO' || this.precadastro.tipo.nome === 'MEDICO')
    },
    possuiFiliais () {
      return this.unidadeMatrizFilial === 'MATRIZ'
    },

    tiposRede () {
      if (this.isPF) {
        return this.tiposRedeCache.filter(tipoRede => tipoRede.nome === 'CONSULTORIO' || tipoRede.nome === 'MEDICO')
      } else {
        return this.tiposRedeCache
      }
    },
    typeInputTipoUnidade () {
      return this.isPF ? 'radio' : 'checkbox'
    },
    isTipoClinica () {
      if (Array.isArray(this.precadastro.tipo)) {
        return this.precadastro.tipo.find(tipo => tipo.nome === 'CLINICA')
      }
      return this.precadastro.tipo.nome === 'CLINICA'
    }
  },
  watch: {
    'tipoPessoa' (newTipo, oldTipo) {
      if (newTipo === 'PJ') {
        this.precadastro.tipo = []
      } else {
        this.precadastro.tipo = []
      }
    }
  },
  data () {
    return {
      tipoPessoa: 'PF',
      exibeMsgSucesso: false,
      uf: null,
      ufs: [],
      tiposRedeCache: [],
      tiposUnidade: [],
      especialidades: [],
      termoPrivacidade: null,
      listaConselhoProfissional: [
        'CRM', 'CRF', 'COREN', 'CREFITO', 'CREFONO', 'CRMV', 'CRN', 'CRO', 'CRP', 'CRTR'
      ],
      quantidades: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10
      ],
      listEspecialidade: [],
      especialidadeTemp: {
        especialidade: null,
        qtdProfissionais: null,
        valorParticular: ''
      },
      precadastro: {
        tipo: [],
        especialidade: null,
        bairro: null,
        cidade: null,
        uf: null,
        razaoSocial: null,
        logradouro: null,
        celular: null,
        email: null,
        telefone: null,
        cep: null,
        cnpj: null,
        nomeFantasia: null,
        responsavel: null,
        username: null,
        password: null
      },
      repeteSenha: null,
      unidadeMatrizFilial: null
    }
  },
  methods: {
    onSearchEspecialidade (search, loading) {
      loading(true)
      this.searchEspecialidade(loading, search, this)
    },
    searchEspecialidade: _.debounce((loading, search, vm) => {
      vm.$store.dispatch('getEspecialidade', search).then(especialidades => {
        loading(false)
        vm.especialidades = especialidades
      })
    }, 350),
    buscaCEP () {
      if (this.precadastro.cep) {
        this.precadastro.cep = this.precadastro.cep.replace(/[-]/g, '')
        if (this.precadastro.cep.length === 8) {
          http.get(`https://viacep.com.br/ws/${this.precadastro.cep}/json/`)
            .then((result) => {
              let endereco = result.data
              this.precadastro.cidade = endereco.localidade
              this.precadastro.bairro = endereco.bairro
              this.precadastro.logradouro = endereco.logradouro
              this.precadastro.uf = endereco.uf
              this.precadastro.complemento = endereco.complemento
            })
        }
      }
    },

    salvar () {
      this.precadastro.matriz = this.unidadeMatrizFilial && this.unidadeMatrizFilial === 'MATRIZ'

      if (this.listEspecialidade && this.listEspecialidade.length > 0) {
        this.precadastro.listDadosConsulta = this.listEspecialidade
      } else {
        this.precadastro.listDadosConsulta = []
        this.precadastro.listDadosConsulta.push({
          especialidade: this.precadastro.especialidade,
          valorParticular: this.precadastro.valorParticular
        })
      }

      if (this.precadastro.password !== this.repeteSenha) {
        this.$toasted.show('As senhas não correspondem', {
          icon: { name: 'fa-exclamation-triangle' },
          type: 'error',
          theme: 'bubble',
          action: {
            text: 'FECHAR',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          }
        })
        return false
      }

      this.$store.dispatch('savePrecadastro', this.precadastro)
        .then(result => {
          this.$toasted.clear()
          window.scrollTo(0, 0)
          this.$router.push({name: 'Precadastro-validacao'})
        })
        .catch(erro => {
          this.exibeMsgSucesso = false
        })
    },

    addEspecialidade () {
      this.listEspecialidade.push(Object.assign({}, this.especialidadeTemp))
      this.especialidadeTemp = {
        especialidade: null,
        qtdProfissionais: null,
        valorParticular: ''
      }
    },

    removeEspecialidade (especialidadeTmp) {
      let index = this.listEspecialidade.indexOf(especialidadeTmp)
      this.listEspecialidade.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/precadastro/Form.vue